import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { 
    IonSpinner
} from '@ionic/angular/standalone';

@Component({
    selector: 'marv-img',
    templateUrl: './img.component.html',
    styleUrls: ['./img.component.scss'],
    imports: [IonSpinner]
})
export class MarvImgComponent  implements OnInit {

    @Input({alias : 'src', required : true}) src: string;  
    @Input({alias : 'srcPictureError', required : false}) srcPictureError: string = 'assets/imgs/pictureNotFound.png';  
    @Input({alias : 'objectFit', required : false}) objectFit: 'cover'|'contain'|'auto' = 'auto';  
    
    isLoading: boolean = false;
    errorImg: boolean = false;
    timeoutLoading: any;

    constructor() { }
        
    ngOnInit() {}

    async ngOnChanges(changes: SimpleChanges) {        
        if(changes['src'] && changes['src'].currentValue){ 
            this.timeoutLoading = setTimeout(() => {
                this.isLoading = true;
            }, 250);
            this.errorImg = false;
        }        
    }
    
    onLoad(){
        if(this.timeoutLoading){
            clearTimeout(this.timeoutLoading);
        }
        this.isLoading = false;
    }
    
    onError(){
        if(this.timeoutLoading){
            clearTimeout(this.timeoutLoading);
        }
        this.isLoading = false;
        this.errorImg = true;
    }
}
